export default __webpack_public_path__ + "static/sge_01-2a82e643579b8a3ad0b6bbadd55a6011.png";